import { ClaveFraccionArancelariaActionTypes, ClaveFraccionArancelariaState, LOAD_FRACCIONARANCELARIA_SUCCESS } from "../types/claveFraccionArancelariaActionTypes";



export default function claveFraccionArancelariaReducer(state = [], action: ClaveFraccionArancelariaActionTypes): ClaveFraccionArancelariaState[]{
    switch (action.type) {
        case LOAD_FRACCIONARANCELARIA_SUCCESS:
            return action.clavesFraccionArancelaria;
        default:
            return state;
    }
}
